<template>
  <div class="pageContents">
    <div class="modBox">
      <h2 class="mb-4">
        お問い合わせフォーム
        <br />
        （法人のお客様向け）​
      </h2>
      <p style="text-align: right">
        ご相談や資料請求についてはこちらからお問合わせください。
        <br />
        後ほど弊社担当者よりご連絡いたします。
      </p>
      <form action="https://go.se-navi.jp/l/1064102/2024-12-25/2b6x8db" method="POST">
        <div class="modFormList__wrapper">
          <dl class="modFormList modFormList--line">
            <dt class="modFormList__title">
              氏名
              <span class="modFormList__title__required">必須</span>
            </dt>
            <dd class="modFormList__cont">
              <ul class="modFormList__cont__listName">
                <li>
                  <input
                    id="LastName"
                    v-model="data.lastName"
                    name="lastname"
                    class="modFormInput"
                    :class="[!data.lastName && data.lastNameError ? 'modFormInput--error' : '']"
                    type="text"
                    placeholder="例）田中"
                    maxlength="40"
                  />
                  <p v-if="!data.lastName && data.lastNameError" class="modFormError">
                    入力してください
                  </p>
                </li>
                <li>
                  <input
                    id="FirstName"
                    v-model="data.firstName"
                    name="firstname"
                    class="modFormInput"
                    :class="[!data.firstName && data.firstNameError ? 'modFormInput--error' : '']"
                    type="text"
                    placeholder="例）太郎"
                    maxlength="40"
                  />
                  <p v-if="!data.firstName && data.firstNameError" class="modFormError">
                    入力してください
                  </p>
                </li>
              </ul>
            </dd>
            <dt class="modFormList__title">
              フリガナ
              <span class="modFormList__title__required">必須</span>
            </dt>
            <dd class="modFormList__cont">
              <ul class="modFormList__cont__listName">
                <li>
                  <input
                    id="furigana_lastname"
                    v-model="data.furiganaLastName"
                    name="furigana_lastname"
                    class="modFormInput"
                    :class="[
                      !data.furiganaLastName && data.furiganaLastNameError
                        ? 'modFormInput--error'
                        : '',
                    ]"
                    type="text"
                    placeholder="例）タナカ"
                    maxlength="40"
                  />
                  <p
                    v-if="!data.furiganaLastName && data.furiganaLastNameError"
                    class="modFormError"
                  >
                    入力してください
                  </p>
                </li>
                <li>
                  <input
                    id="furigana_firstname"
                    v-model="data.furiganaFirstName"
                    name="furigana_firstname"
                    class="modFormInput"
                    :class="[
                      !data.furiganaFirstName && data.furiganaFirstNameError
                        ? 'modFormInput--error'
                        : '',
                    ]"
                    type="text"
                    placeholder="例）タロウ"
                    maxlength="40"
                  />
                  <p
                    v-if="!data.furiganaFirstName && data.furiganaFirstNameError"
                    class="modFormError"
                  >
                    入力してください
                  </p>
                </li>
              </ul>
            </dd>
            <dt class="modFormList__title">
              社名
              <span class="modFormList__title__required">必須</span>
            </dt>
            <dd class="modFormList__cont">
              <input
                id="Company"
                v-model="data.nameCo"
                name="name_co"
                class="modFormInput"
                :class="[!data.nameCo && data.nameCoError ? 'modFormInput--error' : '']"
                type="text"
                placeholder="例）アイムファクトリー株式会社"
              />
              <p v-if="!data.nameCo && data.nameCoError" class="modFormError">入力してください</p>
            </dd>
            <dt class="modFormList__title">
              部署名
              <span class="modFormList__title__required">必須</span>
            </dt>
            <dd class="modFormList__cont">
              <input
                id="Department"
                v-model="data.department"
                name="department"
                class="modFormInput"
                :class="[!data.department && data.departmentError ? 'modFormInput--error' : '']"
                type="text"
                placeholder="例）人事部"
              />
              <p v-if="!data.department && data.departmentError" class="modFormError">
                入力してください
              </p>
            </dd>
            <dt class="modFormList__title">
              メールアドレス
              <span class="modFormList__title__required">必須</span>
            </dt>
            <dd class="modFormList__cont">
              <input
                id="Email"
                v-model="data.email"
                name="email"
                class="modFormInput"
                :class="[!data.email && data.emailError ? 'modFormInput--error' : '']"
                type="email"
                placeholder="例）info@aim-factory.com"
                maxlength="60"
              />
              <p v-if="!data.email && data.emailError" class="modFormError">入力してください</p>
            </dd>
            <dt class="modFormList__title">
              電話番号
              <span class="modFormList__title__required">必須</span>
            </dt>
            <dd class="modFormList__cont">
              <input
                id="Phone"
                v-model="data.tel"
                name="tel"
                class="modFormInput modFormInput--small"
                :class="[!data.tel && data.telError ? 'modFormInput--error' : '']"
                type="text"
                placeholder="例）03-0000-0000"
              />
              <p v-if="!data.tel && data.telError" class="modFormError">入力してください</p>
            </dd>
            <dt class="modFormList__title">
              お問い合わせ項目
              <span class="modFormList__title__required">必須</span>
            </dt>
            <dd class="modFormList__cont">
              <div
                class="modFormSelect"
                :class="[!data.about && data.aboutError ? 'modFormInput--error' : '']"
              >
                <select id="about" v-model="data.about" name="about">
                  <option value="no_set" disabled selected>選択する</option>
                  <option v-for="type in contact_types" :key="type.code" :value="type.name">
                    {{ type.name }}
                  </option>
                </select>
              </div>
              <p v-if="!data.about && data.aboutError" class="modFormError">入力してください</p>
            </dd>
            <dt class="modFormList__title">
              お問い合わせ内容
              <span class="modFormList__title__required">必須</span>
            </dt>
            <dd class="modFormList__cont">
              <textarea
                id="Comments"
                v-model="data.message"
                name="message"
                class="modFormTextarea"
                :class="[!data.message && data.messageError ? 'modFormTextarea--error' : '']"
                placeholder="例）お問合わせ内容を記載してください"
              ></textarea>
              <p v-if="!data.message && data.messageError" class="modFormError">入力してください</p>
            </dd>
          </dl>
        </div>
        <div class="modFormBottom">
          <p class="modFormBottom__text">
            <!-- TODO: No.13 各ページの遷移先 -->
            アイムファクトリー（社内SE転職ナビ）へのご登録および
            <a href="/terms" target="_blank" rel="noopener">ご利用に関する利用規約</a>
            と
            <a href="https://www.aim-factory.com/privacy" target="_blank" rel="noopener">
              個人情報の取り扱い
            </a>
            についてに
            <br class="modBpPc" />
            同意したうえで以下の送信ボタンをクリックしてください。
          </p>
          <button
            type="submit"
            class="w-285x align-items-center justify-content-center d-flex h-48x btn btn-primary size-14 mx-auto mt-4"
            :disabled="data.error"
          >
            <span>規約に同意して送信する</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, onMounted } from 'vue';

const contact_types = [
  { code: 'recruitment_consultation', name: '人材採用について相談したい​' },
  { code: 'service_overview', name: 'サービス概要資料が欲しい​' },
  { code: 'others', name: 'その他​' },
];

const param = reactive({
  windowWidth: 0,
});

onMounted((): void => {
  param.windowWidth = window.innerWidth;
  window.addEventListener('resize', resizeWindow);

  // changeだとフォーカスが外れないと発火しない対策
  const lastname = document.querySelector('#LastName')!;
  lastname.addEventListener('input', () => {
    checkValue(data.lastName, 'lastName');
  });
  const firstname = document.querySelector('#FirstName')!;
  firstname.addEventListener('input', () => {
    checkValue(data.firstName, 'firstName');
  });
  const furigana_lastname = document.querySelector('#furigana_lastname')!;
  furigana_lastname.addEventListener('input', () => {
    checkValue(data.furiganaLastName, 'furiganaLastName');
  });
  const furigana_firstname = document.querySelector('#furigana_firstname')!;
  furigana_firstname.addEventListener('input', () => {
    checkValue(data.furiganaFirstName, 'furiganaFirstName');
  });
  const email = document.querySelector('#Email')!;
  email.addEventListener('input', () => {
    checkValue(data.email, 'email');
  });
  const about = document.querySelector('#about')!;
  about.addEventListener('change', () => {
    checkValue(data.about, 'about');
  });
  const nameCo = document.querySelector('#Company')!;
  nameCo.addEventListener('input', () => {
    checkValue(data.nameCo, 'name_co');
  });
  const department = document.querySelector('#Department')!;
  department.addEventListener('input', () => {
    checkValue(data.department, 'department');
  });
  const tel = document.querySelector('#Phone')!;
  tel.addEventListener('input', () => {
    checkValue(data.nameCo, 'tel');
  });
  const message = document.querySelector('#Comments')!;
  message.addEventListener('input', () => {
    checkValue(data.message, 'message');
  });
});

const resizeWindow = (): void => {
  param.windowWidth = window.innerWidth;
};

const lastName = '';
const firstName = '';
const furiganaLastName = '';
const furiganaFirstName = '';
const email = '';
const about = '';
const message = '';
const nameCo = '';
const department = '';
const tel = '';
// 値のあるなしだけでエラー判定するとページ表示時にも赤字でエラー文言が出るので
// エラーフラグを個別に用意する
const lastNameError = false;
const firstNameError = false;
const furiganaLastNameError = false;
const furiganaFirstNameError = false;
const departmentError = false;
const telError = false;
const emailError = false;
const aboutError = false;
const messageError = false;
const nameCoError = false;
const error = true;

const data = reactive({
  lastName,
  firstName,
  furiganaLastName,
  furiganaFirstName,
  email,
  about,
  message,
  nameCo,
  department,
  tel,
  lastNameError,
  firstNameError,
  furiganaFirstNameError,
  furiganaLastNameError,
  emailError,
  aboutError,
  messageError,
  nameCoError,
  departmentError,
  telError,
  error,
});

const checkValue = (value: string, type: string): void => {
  if (!value) {
    switch (type) {
      case 'lastName':
        data.lastNameError = true;
        break;
      case 'firstName':
        data.firstNameError = true;
        break;
      case 'furiganaLastName':
        data.furiganaLastNameError = true;
        break;
      case 'furiganaFirstName':
        data.furiganaFirstNameError = true;
        break;
      case 'email':
        data.emailError = true;
        break;
      case 'name_co':
        data.nameCoError = true;
        break;
      case 'message':
        data.messageError = true;
        break;
      case 'department':
        data.departmentError = true;
        break;
      case 'tel':
        data.telError = true;
        break;
      case 'about':
        data.aboutError = true;
        break;
    }
  }
  if (
    data.lastName &&
    data.firstName &&
    data.furiganaLastName &&
    data.furiganaFirstName &&
    data.email &&
    data.nameCo &&
    data.message &&
    data.department &&
    data.tel &&
    data.about
  ) {
    data.error = false;
  } else {
    data.error = true;
  }
};
</script>

<style lang="scss">
@import url('@/assets/stylesheets/pages/contact.scss');
</style>
